export default __webpack_public_path__ + "static/media/fpbh0200.fd654f49.png";